export const COLORS = {
  /* -------------------------------------
        BACKGROUND (Deep Premium Gradient)
  ------------------------------------- */
  background: `
    linear-gradient(
      165deg,
      #0a0c12 0%,
      #0c1220 38%,
      #0b1530 72%,
      #08101d 100%
    )
  `,

  /* -------------------------------------
        SURFACES (Soft Glass Layers)
  ------------------------------------- */
  surface: "rgba(255,255,255,0.04)",       // glass matte
  surfaceAlt: "rgba(255,255,255,0.07)",    // slightly stronger
  surfaceDeep: "rgba(0,0,0,0.55)",         // contrast panel depth

  /* -------------------------------------
        ACCENTS (Elite Neon Blues + Cyan)
  ------------------------------------- */
  accent: "#4cd4ff",          // crisp cyan (premium)
  accentSecondary: "#3a6bff", // rich blue-indigo
  success: "#15d19a",
  warning: "#ffb74d",
  danger: "#ff5176",
  gold: "#ffb74d",

  /* -------------------------------------
        TEXT
  ------------------------------------- */
  textPrimary: "#ffffff",
  textSecondary: "rgba(255,255,255,0.75)",
  textMuted: "rgba(255,255,255,0.45)",

  /* -------------------------------------
        BORDERS (Clean, Subtle)
  ------------------------------------- */
  border: "rgba(255,255,255,0.12)",
  borderStrong: "rgba(255,255,255,0.20)",

  /* -------------------------------------
        SHADOWS (Modern Glow)
  ------------------------------------- */
  glow: "0 0 20px rgba(76,212,255,0.22)",
  glowStrong: "0 0 40px rgba(76,212,255,0.35)",
};
